export default "__VITE_ASSET__OEWtpN0j__"